export const LOADING_INDICATOR_POSITION = { top: 8, left: 72 };
